/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import alert from 'react-s-alert';
import InputPassword from 'modules/common/components/InputPassword';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

const INIT_STATE = {
  current_password: '',
  password: '',
  re_password: '',
};

function ChangePasswordModal({ changePassword, history, updating }) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(INIT_STATE);

  const validateForm = useFormValidator(formData, {
    current_password: 'required|password',
    password: 'required|not_match:current_password|password',
    re_password: 'required|match:password|password',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const pass = _.get(formData, 'password');
    const rePass = _.get(formData, 're_password');
    const args = {
      current_password: formData.current_password,
      password: pass,
      password_confirmation: rePass,
    };
    if (pass === rePass) {
      changePassword(args, () => {
        setModal({ isOpen: false });
        history.push('/profile');
      });
    } else {
      alert.error('Password does not match');
    }
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Current Password: {validateForm.renderMessage('current_password')}
            </label>
            <InputPassword
              name="current_password"
              placeholder="Current Password"
              value={_.get(formData, 'current_password')}
              onChange={onChange}
            />
          </div>

          <div className="col-12 form-group">
            <label className="form-label">
              New Password: {validateForm.renderMessage('password')}
            </label>
            <InputPassword
              name="password"
              placeholder="New Password"
              value={_.get(formData, 'password')}
              onChange={onChange}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Re-type New Password: {validateForm.renderMessage('re_password')}
            </label>
            <InputPassword
              name="re_password"
              placeholder="Re-type New Password"
              value={_.get(formData, 're_password')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ChangePasswordModal.propTypes = {
  changePassword: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CHANGE_PASSWORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ChangePasswordModal);
